function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export var Quickbooks = props => /*#__PURE__*/_jsxs("svg", _objectSpread(_objectSpread({
  width: "1em",
  height: "1em",
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 40 40"
}, props), {}, {
  children: [/*#__PURE__*/_jsx("circle", {
    cx: "20",
    cy: "20",
    r: "20",
    fill: "#2CA01C"
  }), /*#__PURE__*/_jsx("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M25.442 12.187h1.088c4.206 0 7.616 3.498 7.616 7.814 0 4.315-3.41 7.813-7.616 7.813h-5.443V6.83c1.562 0 2.829 1.3 2.829 2.902v15.18h2.614c2.64 0 4.787-2.202 4.787-4.91 0-2.709-2.147-4.912-4.787-4.912h-1.088v-2.902ZM13.47 27.813c-4.206 0-7.616-3.498-7.616-7.813 0-4.316 3.41-7.814 7.616-7.814h5.443V33.17c-1.562 0-2.829-1.3-2.829-2.902v-15.18H13.47c-2.64 0-4.787 2.202-4.787 4.91 0 2.709 2.147 4.912 4.787 4.912h1.088v2.902H13.47Z",
    clipRule: "evenodd"
  })]
}));
//# sourceMappingURL=Quickbooks.js.map